<template>
  <div>
    <Loading type="line" :center="false" v-show="loading"/>
    <ScrollBar :minHeight="150" :maxHeight="300">
      <table class="table table-responsive-xs">
        <thead>
        <tr>
          <th><span class="title-header">Produto</span></th>
          <th class="text-center"><span class="title-header">Quantidade</span></th>
          <th class="text-center" v-if="manageByPatrimony"><span class="title-header">Patrimônio(s)</span></th>
          <th class="text-center"><span class="title-header">Período</span></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in items" :key="item.id">
          <td>{{ item.productFullName }}</td>
          <td class="text-center">{{ item.quantity }}</td>
          <td class="text-center" v-if="manageByPatrimony">{{ item.patrimony }}</td>
          <td class="text-center td-period">
            <span class="badge-period">{{ item.periodRentName }}</span>
          </td>
        </tr>
        <tr v-show="!loading && items.length === 0">
          <td colspan="4">
            <span class="title">Nenhum registro encontrado!</span>
          </td>
        </tr>
        </tbody>
      </table>
    </ScrollBar>
  </div>
</template>

<script>
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import ScrollBar from "@nixweb/nixloc-ui/src/component/layout/ScrollBar.vue";
import {mapActions, mapState} from "vuex";

export default {
  name: "MovimentProductList",
  components: {Loading, ScrollBar},
  props: {
    movimentId: {type: String, required: true},
  },
  data() {
    return {
      urlGetApi: "/api/v1/stock/items-moviment/get-all",
      loading: false,
      items: [],
    };
  },
  mounted() {
    this.getAll();
  },
  computed: {
    ...mapState("user", ["userLogged"]),
    manageByPatrimony() {
      return this.userLogged.parameterStock.manageByPatrimony;
    },
  },
  methods: {
    ...mapActions("generic", ["getApi"]),
    getAll() {
      this.loading = true;
      this.items = [];
      let params = {
        url: this.urlGetApi,
        obj: {any: this.movimentId, noPaginated: true},
      };
      this.getApi(params).then((response) => {
        this.items = response.content.data || response.content;
        this.loading = false;
      });
    },
  },
  watch: {
    movimentId(newVal) {
      if (newVal) this.getAll();
    },
  },
};
</script>

<style scoped>
.table th,
.table td {
  padding: 7px 10px 5px 10px !important;
  border-bottom: 1px solid #e9ecef !important;
}

.title-header {
  font-size: 14px;
  color: #757d8c;
  font-weight: 400;
  text-transform: uppercase;
}

.td-period {
  white-space: nowrap;
}

.badge-period {
  display: inline-block;
  background-color: #EEEEEE;
  color: #000000;
  font-size: 11px;
  padding: 3px 10px;
  border-radius: 50px;
}
</style>
